import styled from 'styled-components';
import { Box, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const CustomField = styled(TextField)`
  .MuiInputBase-root {
    border: 0;
    &:before,
    &:after {
      border-bottom: none !important;
    }
  }

  .MuiInputBase-input {
    text-align: center;
    width: 100%;
  }
`;

function FeatureSearchInput({
  label,
  name,
  placeholder,
  showBorder,
  inputType,
  fieldValue,
  onChange,
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      py={2}
      borderRight={showBorder ? '1px solid rgba(0, 0, 0, .2)' : ''}>
      <Typography variant="h6" fontWeight="bold">
        {label}
      </Typography>
      <CustomField
        name={name}
        type={inputType}
        variant="standard"
        placeholder={placeholder}
        value={fieldValue}
        onChange={onChange}
        fullWidth
      />
    </Box>
  );
}

FeatureSearchInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  showBorder: PropTypes.bool,
  inputType: PropTypes.string,
  fieldValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

FeatureSearchInput.defaultProps = {
  label: '',
  name: '',
  placeholder: '',
  showBorder: true,
  inputType: 'text',
};

export default FeatureSearchInput;
